import _extends from "@babel/runtime/helpers/esm/extends";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import { useSuperIntl } from "../_";
import { BetaSchemaForm } from '@ant-design/pro-components';
import { useDeepCompareEffect } from 'ahooks';
import React, { useRef } from 'react';
export var SuperProTableFilter = function SuperProTableFilter(properties) {
  var intl = useSuperIntl();
  var operator = useRef();
  useDeepCompareEffect(function () {
    var _operator$current;
    (_operator$current = operator.current) === null || _operator$current === void 0 || _operator$current.setFieldsValue({
      chips: properties.context.parameters[0].searcher || []
    });
  }, [properties.open, properties.context.parameters[0].searcher]);
  return /*#__PURE__*/React.createElement(BetaSchemaForm, _extends({
    formRef: operator,
    title: intl.formatMessage({
      id: 'Filter'
    }),
    initialValues: {}
    // @ts-ignore
    ,
    modalProps: {
      destroyOnClose: false
    },
    grid: true,
    rowProps: {
      gutter: [12, 12]
    },
    onFinish: function onFinish(formData) {
      //
      properties.context.parameters[1]({
        searcher: formData.chips
      });
      //
      return Promise.resolve(true);
    }
  }, properties, {
    layoutType: "ModalForm",
    columns: [{
      valueType: 'formList',
      dataIndex: 'chips',
      formItemProps: {
        style: {
          marginBottom: 0
        }
      },
      columns: [{
        valueType: 'group',
        columns: [{
          valueType: 'text',
          formItemProps: {
            rules: [{
              required: true
            }]
          },
          title: intl.formatMessage({
            id: 'Key'
          }),
          dataIndex: 'key',
          colProps: {
            span: 8
          }
        }, {
          valueType: 'select',
          formItemProps: {
            rules: [{
              required: true
            }]
          },
          dataIndex: 'operator',
          title: intl.formatMessage({
            id: 'Operator'
          }),
          valueEnum: {
            '=': intl.formatMessage({
              id: 'Equal To'
            }),
            '≠': intl.formatMessage({
              id: 'Not Equal To'
            }),
            '≈': intl.formatMessage({
              id: 'Similar To'
            }),
            '!≈': intl.formatMessage({
              id: 'Not Similar To'
            }),
            '>': intl.formatMessage({
              id: 'Greater Than'
            }),
            '<': intl.formatMessage({
              id: 'Less Than'
            }),
            '>=': intl.formatMessage({
              id: 'Greater Than Or'
            }),
            '<=': intl.formatMessage({
              id: 'Less Than Or'
            }),
            '⊇': intl.formatMessage({
              id: 'In'
            }),
            '⊉': intl.formatMessage({
              id: 'Not In'
            }),
            '[]': intl.formatMessage({
              id: 'Between'
            }),
            '![]': intl.formatMessage({
              id: 'Not Between'
            })
          },
          colProps: {
            span: 8
          }
        }, {
          valueType: 'dependency',
          name: ['key'],
          columns: function columns(_ref) {
            var key = _ref.key;
            return [_objectSpread(_objectSpread({}, properties.columns.find(function (_column_) {
              return _column_.dataIndex === key;
            })), {}, {
              formItemProps: {
                rules: [{
                  required: true
                }]
              },
              title: intl.formatMessage({
                id: 'Value'
              }),
              dataIndex: 'value',
              colProps: {
                span: 8
              }
            })];
          }
        }]
      }]
    }]
  }));
};